import { Stack, Typography } from "@mui/material";
import { CreateButton } from "react-admin";
import useAppBarHeight from "../misc/useAppBarHeight";

export const ContactEmpty = () => {
  const appbarHeight = useAppBarHeight();
  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      gap={3}
      sx={{
        height: `calc(100dvh - ${appbarHeight}px)`,
      }}
    >
      <img src="./img/empty.svg" alt="Nenhum contato encontrado" />
      <Stack gap={0} alignItems="center">
        <Typography variant="h6" fontWeight="bold">
          Nenhuma Análise encontrada
        </Typography>
        <Typography
          variant="body2"
          align="center"
          color="text.secondary"
          gutterBottom
        >
          Sua lista de Análises está vazia.
        </Typography>
      </Stack>
      <Stack spacing={2} direction="row">
        <CreateButton variant="contained" label="Nova Análise" />
      </Stack>
    </Stack>
  );
};
